<div class="main px-5">
  <div class="col-12 mt-3 py-2 px-5 bg-light-color" [class.d-none]="route.children.length !== 0">
    <div class="col-12 d-flex mt-3 align-items-center">
      <div class="d-flex col-6">
        <h1 class="fs-4 fw-bold text-primary-color mt-3">Movimentação Societária</h1>
      </div>
      <div class="d-flex col-6 justify-content-end">
        <button nz-button type="button" nzType="default" [nzSize]="size" class="rounded-pill me-2" (click)="abrirExportarHistoricoModal()">
          Exportar Relatório de Histórico
        </button>
        <ng-template [ngxPermissionsOnly]="[roleEnum.MudancaEntidadeGravacao]">
          <button nz-button type="button" nzType="primary" [nzSize]="size" class="rounded-pill" (click)="incluirMovimentacaoSocietaria()">
            Adicionar Movimentação Societária
          </button>
        </ng-template>
      </div>
    </div>

    <nz-divider class="m-0 p-0 mt-3 mb-3"></nz-divider>

    <div class="d-flex">
      <div class="col-12 px-0 py-3 border-gray box-shadow">
        <form [formGroup]="movimentacaoSocietariaFilterForm" id="movimentacaoSocietariaFilterForm">

          <div class="row g-4 mb-2">

            <div class="col-sm-6 form-group">
              <label for="nomeParticipantes" class="form-label">Nome das Entidade Envolvidas</label>
              <nz-input-group nzSize="large">
                <input nz-input id="nomeParticipantes" formControlName="nomeParticipantes" placeholder="Nome das Entidade Envolvidas" />
              </nz-input-group>
            </div>
            <div class="col-sm-4 form-group">
              <label for="cnpj" class="form-label">CNPJ</label>
              <nz-input-group nzSize="large">
                <input nz-input id="cnpj" formControlName="cnpj" placeholder="CNPJ" mask="00.000.000/0000-00"/>
              </nz-input-group>
            </div>
            <div class="col-sm-4 form-group">
              <label for="tipoMudancaEntidade" class="form-label">Tipo de Mudança</label>
              <nz-select formControlName="tipoMudancaEntidade" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large">
                <nz-option [nzValue]="item.id" [nzLabel]="item.nomeTipoMudancaEntidade"
                  *ngFor="let item of tipoMudancaLista" />
              </nz-select>
            </div>
            <div class="col-sm-4 form-group">
              <label for="dataDe" class="form-label">Data de mudança de</label>
              <nz-date-picker id="dataDe" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'" formControlName="dataDe" (input)="onInputDateChange($event, 'dataDe')" [nzAllowClear]="true"></nz-date-picker>
            </div>
            <div class="col-sm-4 form-group">
              <label for="dataAte" class="form-label">Data de mudança ate</label>
              <nz-date-picker id="dataAte" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'" formControlName="dataAte" (input)="onInputDateChange($event, 'dataAte')" [nzAllowClear]="true"></nz-date-picker>
            </div>
            <div class="col-sm-12 form-group d-flex justify-content-end mt-4 mb-3">
              <button nz-button type="button" nzType="primary" [nzSize]="'large'" class="rounded-pill me-2"
                form="entidadeFilterForm" (click)="pesquisar()">
                Pesquisar
              </button>
              <button nz-button type="button" nzType="default" [nzSize]="'large'" class="rounded-pill"
                form="entidadeFilterForm" (click)="resetForm()">
                Limpar Filtros
              </button>
            </div>
          </div>
        </form>

        <nz-divider class="m-0 p-0 mt-4"></nz-divider>

        <div class="d-flex flex-column page-content border border-radius w-100 mt-4">
          <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
            (nzQueryParams)="sort($event)" [nzFooter]="footerTemplate" [nzNoResult]="semDadosTemplate" [nzScroll]="{ x: 'max-content' }">
            <thead>
              <tr>
                <th nzColumnKey="dataMudanca" nzShowSort [nzSortFn]="true">Data de Mudança</th>
                <th nzColumnKey="novaRazaoSocial" nzShowSort [nzSortFn]="true">Razão Social</th>
                <th nzColumnKey="razaoSocialAnterior" nzShowSort [nzSortFn]="true">Razão Social Anterior</th>
                <th nzColumnKey="entidadesEnvolvidas" nzShowSort [nzSortFn]="true">Entidades Envolvidas</th>
                <th nzColumnKey="cnpjs" nzWidth="150px" nzShowSort [nzSortFn]="true">CNPJ</th>
                <th nzColumnKey="tipoMudancaEntidade?.nomeTipoMudancaEntidade" nzShowSort [nzSortFn]="true">Tipo de Mudança</th>
                <th class="text-center" nzWidth="80px" [nzRight]="true">Ações</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="paginator?.paginaAtual">
                <tr *ngFor="let item of dataSet">
                  <td>{{ item?.dataMudanca | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ item?.novaRazaoSocial }}</td>
                  <td>{{ item?.razaoSocialAnterior }}</td>
                  <td>{{ item?.entidadesEnvolvidas }}</td>
                  <td>{{ item?.cnpjs | cnpj }}</td>
                  <td>{{ item?.tipoMudancaEntidade?.nomeTipoMudancaEntidade }}</td>
                  <td class="text-center" [nzRight]="true">
                    <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
                      <span nz-icon nzType="more" nzTheme="outline"></span>
                    </button>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                      <ul nz-menu>

                        <li nz-menu-item>
                          <a type="button" (click)="editarMovimentacaoSocietaria(item)">Consultar/Editar</a>
                        </li>
                      </ul>
                    </nz-dropdown-menu>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </nz-table>
          <ng-template #footerTemplate>
            <section class="d-flex justify-content-end w-100">
              <app-pagination [itemPorPagina]="10"></app-pagination>
            </section>
          </ng-template>
          <ng-template #semDadosTemplate>
            <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
              <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<div>
  <router-outlet></router-outlet>
</div>
